import { render, staticRenderFns } from "./ModalAbout.vue?vue&type=template&id=3bf4a90f&scoped=true"
import script from "./ModalAbout.vue?vue&type=script&lang=js"
export * from "./ModalAbout.vue?vue&type=script&lang=js"
import style0 from "./ModalAbout.vue?vue&type=style&index=0&id=3bf4a90f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4a90f",
  null
  
)

export default component.exports